import { render, staticRenderFns } from "./jspdfGenerator.vue?vue&type=template&id=379cd02e&scoped=true"
import script from "./jspdfGenerator.vue?vue&type=script&lang=js"
export * from "./jspdfGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379cd02e",
  null
  
)

export default component.exports